


import React, { useState,useEffect } from 'react';
import Newtodoitem from './mycomponents/Newtodoitem';
import './App.css';
import db from "./firebase";
import { Button,FormControl,InputLabel,Input } from '@material-ui/core';
import firebase from "firebase";
function App() {
  const [todo, settodo] = useState([]);
  const [input, setinput] = useState('');
  
  
  useEffect(() => {
   db.collection('todos').orderBy('timestamp','desc').onSnapshot(snapshot=>{
  
      settodo(snapshot.docs.map(doc=>({id:doc.id, todo:doc.data().todo})))
   })
  }, []);



 
  function additem(event){
    event.preventDefault();
  
   db.collection('todos').add({
     todo:input,
     timestamp:firebase.firestore.FieldValue.serverTimestamp()
   })

    settodo([...todo,input]);
   
    
  
    setinput('');
    
   
 
    
  }

 
 return (

   
       

    <div className="App">
<br />
      <h1>My Own Todo List</h1>
     
     <br />
      

     <form action="">
     <FormControl>
     < InputLabel>Write A Todo</InputLabel>
<Input  value={input} onChange={event=>setinput(event.target.value)} id="standard-basic" />  


</FormControl>
   
     <Button type="submit"  disabled={!input} onClick={additem} variant="contained" color="primary">
      addtodo
      </Button>
     
     
     </form>
     
     
     <center><ul  type="none">
       
       
       {
         todo.map(todos=>(
           
            <Newtodoitem item={todos}></Newtodoitem>
         
          
         ))
       }
 


      
     
      
    </ul></center> 

    </div>


  );
 
 
        }
export default App;
